"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CVCard = void 0;
exports.renderCVSection = renderCVSection;
var _litHtml = require("lit-html");
require("../../styles/CVCard.css");
var _texts = require("../../texts");
var _ResumeEditDialog = require("./ResumeEditDialog");
var _sectionCardHelpers = require("../shared/sectionCardHelpers");
var _collapsibleSection = require("../shared/collapsibleSection");
var _profileIcons = require("../../icons-svg/profileIcons");
function renderRole(role, index) {
  if (!role) return (0, _litHtml.html)``;
  const roleTitleId = `cv-role-title-${index}`;
  const rolePeriodId = `cv-role-period-${index}`;
  const roleOrgId = `cv-role-org-${index}`;
  const roleDescriptionId = `cv-role-description-${index}`;
  const ariaDescribedBy = role.description ? `${rolePeriodId} ${roleOrgId} ${roleDescriptionId}` : `${rolePeriodId} ${roleOrgId}`;
  return (0, _litHtml.html)`
    <li class="cvRole" role="listitem" aria-labelledby=${roleTitleId} aria-describedby=${ariaDescribedBy}>
    <div class="cvRoleHeader">
      <h4 id=${roleTitleId}>${role.title}</h4>
      <p id=${rolePeriodId} class="cvRolePeriod">
        <time datetime=${(0, _sectionCardHelpers.toMonthDateTime)(role.startDate)}>${(0, _sectionCardHelpers.formatMonthYear)(role.startDate)}</time>
        <span aria-hidden="true"> to </span>
        ${role.endDate ? (0, _litHtml.html)`<time datetime=${(0, _sectionCardHelpers.toMonthDateTime)(role.endDate)}>${(0, _sectionCardHelpers.formatMonthYear)(role.endDate)}</time>` : (0, _litHtml.html)`<span>Present</span>`}
      </p>
    </div>
      <p class="cvOrg" id=${roleOrgId}>
        <strong>${role.orgName}</strong>${role.orgLocation ? (0, _litHtml.html)` | ${role.orgLocation}` : ''}
      </p>
      ${role.description ? (0, _litHtml.html)`
        <div class="cvDescriptionWrap">
          <p class="cvDescriptionText" id=${roleDescriptionId}>${role.description}</p>
          <button
            type="button"
            class="cvDescriptionToggle"
            aria-controls=${roleDescriptionId}
            aria-expanded="false"
            hidden
            @click=${_sectionCardHelpers.toggleDescription}
          >
            ...more
          </button>
        </div>
      ` : ''}
    </li>
  `;
}
function renderRoles(roles) {
  if (!roles || !roles.length) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${roles.map((role, index) => renderRole(role, index))}`;
}
const CVCard = (cvData, viewerMode) => {
  void viewerMode;
  const hasRoles = Array.isArray(cvData) && cvData.length > 0;
  if (!hasRoles) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`
    <article class="cvCard" aria-label="Resume" data-testid="curriculum-vitae">
      <section class="cvSection">
        <ul role="list" aria-label="Work experience in chronological order">
          ${renderRoles(cvData)}
        </ul>
      </section>
    </article>
  `;
};
exports.CVCard = CVCard;
function renderResumeSectionDefault(store, subject, resumeDetails, viewerMode, onSaved) {
  (0, _sectionCardHelpers.scheduleDescriptionOverflowCheck)();
  const hasResume = resumeDetails.length > 0;
  const showSection = true;
  const cv = hasResume ? CVCard(resumeDetails, viewerMode) : (0, _litHtml.html)``;
  const isOwner = viewerMode === 'owner';
  return showSection ? (0, _litHtml.html)`
    <section 
      aria-labelledby="cv-heading" 
      class="profile__section border-lighter profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="cv-heading" tabindex="-1">${_texts.resumeHeadingText}</h2>
        <div class="profile-section-collapsible__actions flex-column">
          ${isOwner ? (0, _litHtml.html)`
            <button
              type="button"
              class="profile__action-button profile-action-text flex-center profile-section-collapsible__edit-button"
              aria-label="Edit resume details"
              @click=${event => (0, _ResumeEditDialog.createResumeEditDialog)(event, store, subject, resumeDetails, viewerMode, onSaved)}
            >
              <span class="profile-section-collapsible__edit-label">${_profileIcons.editIcon} Edit</span>
              <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
            </button>
          ` : (0, _litHtml.html)``}
          <button
            type="button"
            class="inline-flex-row"
            aria-label="Toggle resume section"
            aria-controls="cv-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span class="profile-section-collapsible__chevron" aria-hidden="true">⌄</span>
          </button>
        </div>
      </header>
      <div id="cv-panel" class="profile-section-collapsible__content" aria-hidden="true">
        ${hasResume ? cv : (0, _litHtml.html)`<p>No resume details added yet.</p>`}
      </div>
    </section>
  ` : '';
}
function renderOwnerEmptyResumeContent(store, subject, resumeDetails, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <div class="profile__empty-state-content flex-column-center" role="group" aria-label="Empty resume section">
      <h2 id="resume-heading" tabindex="-1">${_texts.resumeHeadingText}</h2>
      <p class="profile__empty-state-message">
        You haven't included any professional experience yet. Consider adding your work history to enhance your resume.
      </p>
    </div>
    <button
      type="button"
      class="profile__action-button--empty"
      aria-label="Add resume details"
      @click=${event => {
    return (0, _ResumeEditDialog.createResumeEditDialog)(event, store, subject, resumeDetails, viewerMode, onSaved);
  }}
    >
      <span class="profile__action-icon" aria-hidden="true">${_profileIcons.plusDarkIcon} Add Resume</span>
    </button>

  `;
}
function renderOwnerEmptyResumeSection(store, subject, resumeDetails, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="resume-heading" 
      data-profile-section="resume"
      class="profile__section--empty border-lighter flex-column-center rounded-md gap-lg" 
      role="region"
      tabindex="-1"
    >
      ${renderOwnerEmptyResumeContent(store, subject, resumeDetails, viewerMode, onSaved)}
    </section>
  `;
}
function renderCVSection(store, subject, roles, viewerMode, onSaved) {
  const resumeDetails = roles || [];
  const hasResume = resumeDetails.length > 0;
  const showOwnerEmptyResume = !hasResume && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyResume ? renderOwnerEmptyResumeSection(store, subject, resumeDetails, viewerMode, onSaved) : renderResumeSectionDefault(store, subject, resumeDetails, viewerMode, onSaved)}
  ` : '';
}